import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Financial from './financial';
import Overview from './overview/Overview';
import Performance from './performance';
import Technical from './technical';
import {
  cancelFetchListTopNewLowTable,
  fetchListTopNewLowTable,
  REDUCER_NAME,
} from './reducer';
import Chart from './chart/Chart';
import Footer from '../../../common/table/Footer';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class AllExchanges extends AutoReloadOnFocusBlurComponent {
  reload() {
    const { dispatch, filter, timeRange } = this.props;
    dispatch(fetchListTopNewLowTable(filter, timeRange));
  }

  componentDidMount() {
    super.componentDidMount();
    const { dispatch, filter, timeRange } = this.props;
    dispatch(fetchListTopNewLowTable(filter, timeRange));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, filter, timeRange } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      dispatch(fetchListTopNewLowTable(filter, timeRange));
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    const { dispatch } = this.props;
    dispatch(cancelFetchListTopNewLowTable());
  }

  render() {
    const { typeTab, timeRange } = this.props;
    return (
      <div className="tab-pane active top-mover-content d-flex flex-fill flex-column">
        {typeTab !== 5 && (
          <div className="d-flex flex-column flex-fill pl-20 pr-20">
            {typeTab === 1 && <Overview />}
            {typeTab === 2 && <Performance />}
            {typeTab === 3 && <Financial />}
            {typeTab === 4 && <Technical />}

            <Footer
              listTextLang={[
                {
                  text: I18n.t('topNewHigh.topNewLowFooter', {
                    time: I18n.t(
                      `topNewHigh.timeRangeList.${timeRange}`,
                    ).toLowerCase(),
                  }),
                },
              ]}
            />
          </div>
        )}
        {typeTab === 5 && <Chart />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  timeRange: state[REDUCER_NAME].timeRange,
});

export default connect(mapStateToProps)(AllExchanges);
